<!-- Card 1 -->
<c-card class="mb-5">
  <c-card-header>
    <h5>Exchange History (Section 1)</h5>
  </c-card-header>
  <c-card-body>
    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="thead-light">
          <tr>
            <th>Token</th>
            <th *ngFor="let exchange of exchanges">{{ exchange }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let token of tokens">
            <td>{{ token }}</td>
            <td *ngFor="let exchange of exchanges">
              {{ getData(token, exchange) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </c-card-body>
</c-card>

<!-- Card 2 -->
<c-card class="mb-5">
  <c-card-header>
    <h5>Exchange History (Section 2)</h5>
  </c-card-header>
  <c-card-body>
    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="thead-light">
          <tr>
            <th>Token</th>
            <th *ngFor="let exchange of exchanges">{{ exchange }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let token of tokens">
            <td>{{ token }}</td>
            <td *ngFor="let exchange of exchanges">
              {{ getData(token, exchange) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </c-card-body>
</c-card>
